"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInlineDateFieldFactory = void 0;
const react_1 = __importStar(require("react"));
const form_date_field_1 = require("../../../composite/form/fields/form-date-field");
const inline_table_context_1 = require("../inline-table-context");
function useInlineDateFieldFactory(props) {
    return react_1.useMemo(() => function InlineCell(tableFieldProps) {
        return (react_1.default.createElement(InlineDateFieldCell, { inlineProps: props, tableFieldProps: tableFieldProps }));
    }, [props]);
}
exports.useInlineDateFieldFactory = useInlineDateFieldFactory;
function InlineDateFieldCell({ inlineProps, tableFieldProps, }) {
    const { disabled: tableDisabled } = react_1.useContext(inline_table_context_1.InlineTableFieldContext);
    const { isSubkey = true, collectionDatakey, disabled, representation, } = inlineProps;
    const { index, column } = tableFieldProps;
    return (react_1.default.createElement(form_date_field_1.FormDateField, { name: isSubkey
            ? `${collectionDatakey}[${index}].${column.datakey}`
            : `${collectionDatakey}[${index}]`, labelOptions: { hide: true }, layoutOptions: { noUnderline: true }, disabled: tableDisabled ||
            (typeof disabled === 'function' ? disabled(index) : disabled), representation: representation }));
}
//# sourceMappingURL=inline-date-field-cell.js.map